import React, { Fragment } from 'react'
import classnames from 'classnames/bind'
import Modal from '../../../overlays/modal'
import Text from '../../../elementals/text'
import styles from '../styles.scss'
import { isPrivateSeller } from './utils'
import { BADGE_MODE } from './base'
import FullWidthBadge from './fullWidthBadge'

const cx = classnames.bind(styles)

export default class TitleAndLiensBadge extends FullWidthBadge {
  static summary = 'Title and Liens'

  static titleIcon = 'file-certificate'

  static contentPositive = false

  static shouldBeHoisted = true

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return badgeMode === BADGE_MODE.EXPANDED && !isPrivateSeller(listing)
  }

  get content() {
    return (
      <>
        Most liens are removed after a foreclosure property sale, but certain
        liens may remain.{' '}
        <Modal
          title='Title and Liens'
          size='tiny'
          mobileTitleSkin='light'
          fullScreen='mobileOnly'
          elmId='occupancy_modal'
          trigger={
            <a data-elm-id='liens_modal_trigger'>What type of liens remain?</a>
          }
        >
          <Modal.Content data-elm-id='liens_modal_content'>
            <Text className={cx('modal-content')}>
              <div className={cx('u-mt-1')}>
                Most Liens are removed after a foreclosure property sale, but
                certain liens may remain.
              </div>
              <div className={cx('u-mt-2')}>Here are some examples:</div>
              <ul>
                <li>
                  Any lien recorded on title prior in time to the foreclosing
                  mortgage.
                </li>
                <li>
                  First Mortgage (if the foreclosing mortgage is a second or
                  third mortgage
                </li>
                <li>HOA or COA assessment liens (in certain states)</li>
                <li>Mechanic’s Liens (in some states)</li>
                <li>
                  Government liens such as state and federal tax liens, city or
                  county liens, US Government liens.
                </li>
                <li>
                  IRS liens (IRS may buy the property within 120 days after sale
                  at the price paid at foreclosure sale)
                </li>
                <li>
                  Code Enforcement Liens, Environmental Liens, and Utility Liens
                </li>
                <li>Child Support Liens</li>
              </ul>
            </Text>
          </Modal.Content>
        </Modal>
      </>
    )
  }
}
